import React, { useEffect, useState, useMemo } from "react";
import jsPDF from "jspdf";
import { Link } from "react-router-dom";
import axios from "axios";
import DataTable from "react-data-table-component";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import { ERROR_MESSAGE } from "../../../../src/common/Constant";
import { toastError, toastSuccess } from "../../../../src/common/Toast";
import DeleteConfirmationModal from "../../../components/Modal/DeleteConfirmation";
import CleanupConfirmationModal from "../../../../src/components/Modal/CleanupConfirmation";
import * as XLSX from "xlsx";

const GiftCard = () => {
  let selectData = [];
  let pathforpdf = "";
  const token = localStorage.getItem("Token");
  const [perPageSize, setperPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [sortingId, setSortingId] = useState(6);

  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [toggleCleared, setToggleCleared] = useState(false);

  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [selectedGiftCardCheckboxs, setselectedGiftCardCheckbox] = useState("");
  const [state, setState] = useState("");
  const [selectedGiftCardCheckEmails, setselectedGiftCardCheckEmails] =
    useState("");
  const [selectedGiftCardCheckpathforpdf, setselectedGiftCardCheckpathforpdf] =
    useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedDataDelete, setSelectedDataDelete] = useState("");

  // Get all tag data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder
  ) => {
    setLoading(true);
    axios
      .get(
        `${config.giftcardBaseUrl}/giftcards/selectall?pagenumber=${pagenumber}&pagesize=${pagesize}&filtertext=${filtertext}&ordercolumn=${ordercolumn}&currentorder=${currentorder}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const toogleSelection = (event) => {
    setToggleCleared(!toggleCleared);
  };

  const handleDeletePopup = (pID) => {
    const deleteRequestParam = {
      id: pID || selectedDataDelete,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
  };

  const handleRowSelected = (e) => {
    if (e.selectedRows.length > 0) {
      // for get detlais form id
      setSelectedRows(e.selectedRows.map((x) => x.Id));
      selectData[currentPage] = e.selectedRows.map((x) => x.Id);
      const selectedGiftCardCheckboxIDs =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      const selectedDataDelete =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      setSelectedDataDelete(selectedDataDelete);
      setselectedGiftCardCheckbox(selectedGiftCardCheckboxIDs);
      const datasplitforpath = selectedGiftCardCheckboxIDs?.split(",");
      pathforpdf = datasplitforpath?.join("~");
      setselectedGiftCardCheckpathforpdf(pathforpdf);
    }
  };

  const contextActions = useMemo(() => {
    return (
      <>
        {/* Delete */}
        <button
          type="button"
          className="btn btn-danger btn-sm pull-left"
          data-bs-toggle="modal"
          data-bs-target="#DeleteConfirmationModal"
          onClick={() => handleDeletePopup()}
        >
          <i className="fa fa-trash fa-sm" /> Delete Selected
        </button>

        {/* Clear Selection */}
        <div className="row px-2">
          <div className="col-12 align-self-center">
            <button
              type="button"
              className="btn btn-dark btn-sm"
              title="Clear Selection"
              onClick={(event) => toogleSelection(event)}
            >
              <i className="fa fa-envelope-square fa-sm" /> Clear Selection
            </button>
          </div>
        </div>
      </>
    );
  }, [data, selectedRows, toggleCleared]);

  useEffect(() => {
    handleListData(1, perPageSize, searchtext, sortingId, sortingDirection);
  }, []);

  // Table Data
  const columns = [
    {
      name: "ID",
      selector: "Id",
      sortable: true,
    },
    {
      name: "Giftcard Number",
      selector: "GiftcardNumber",
      sortable: true,
    },
    {
      name: "Value",
      selector: "Value",
      sortable: true,
      cell: (row) => (row.Value ? `${Number(row.Value).toFixed(2)}` : ""),
    },
    {
      name: "Description",
      selector: "Description",
      sortable: true,
    },
    {
      name: "Customer Name",
      selector: "CustomerName",
      sortable: true,
    },
    {
      name: "Active/Inactive",
      selector: "ActiveInactive",
      sortable: true,
    },
    {
      name: "	Clone",
      selector: "	Clone",
      sortable: true,
      cell: (row) => <a href={`/manage-giftcard/${row.Id}`}>Clone</a>,
    },
    {
      name: "Action",
      width: "5%",
      cell: (row) => (
        <>
          <Link className="me-3" to={`/manage-giftcard/${row.Id}`}>
            <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
          </Link>

          <Link
            className="confirm-text"
            to="#"
            title="Delete"
            data-bs-toggle="modal"
            data-bs-target="#DeleteConfirmationModal"
            onClick={() => handleDeletePopup(row.Id)}
          >
            <i
              className="fa fa-trash text-red fa-2x"
              data-bs-toggle="tooltip"
              title="Delete"
            ></i>
          </Link>
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];
  const handleExcelExport = () => {
    setLoading(true);
    axios
      .post(
        `${config.giftcardBaseUrl}/giftcards/excelexport`,
        {
          filtertext: searchtext,
          ordercolumn: sortingId,
          currentorder: sortingDirection,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("res ==> ", res.data.ResponseData);

        const data =
          res.data.ResponseData.length > 0 ? res.data.ResponseData : [];

        // Create a new workbook
        const workbook = XLSX.utils.book_new();

        // Convert the data to a worksheet
        const worksheet = XLSX.utils.json_to_sheet(data);

        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // Save the workbook as an Excel file
        XLSX.writeFile(workbook, `giftcard_details_.xlsx`);
        setLoading(false);
      })
      .catch((err) => {
        toastError(ERROR_MESSAGE);
        setLoading(false);
      });
  };

  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPageSize, searchtext, sortingId, sortingDirection);
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(1, perPageSize, searchtext, e.id, sortingDirection);
  };

  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPageSize, e.target.value, sortingId, sortingDirection);
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col">
                <h3 className="page-title">Gift Cards</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Gift Cards</li>
                </ul>
              </div>
            </div>
            <div>
              <div className="btn-group pull-right ms-2">
                <button type="button" className="btn btn-outline-dark d-none">
                  More
                </button>
                <button
                  type="button"
                  className="btn btn-outline-dark dropdown-toggle me-1"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ borderRadius: "5px" }}
                >
                  More &nbsp;
                </button>
                <div className="dropdown-menu">
                  <li>
                    <li>
                      <Link
                        className="dropdown-item"
                        onClick={handleExcelExport}
                      >
                        Excel Export
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item">Buy Gift Cards</Link>
                    </li>

                    <li>
                      <Link
                        to="#"
                        title="Cleanup old Employees"
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#CleanupConfirmationModal"
                      >
                        Cleanup Deleted Gift Cards
                      </Link>
                      <li>
                        <Link className="dropdown-item" to="/deleted-giftcard">
                          Manage Deleted Gift Cards
                        </Link>
                      </li>
                    </li>
                  </li>
                </div>
              </div>

              <Link to="/manage-giftcard" className="btn btn-added pull-right">
                <i className="fa fa-plus me-2 lg"></i>
                New GiftCard
              </Link>
            </div>
          </div>

          <div className="row flex-row-reverse mt-2">
            <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
              <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-50 pull-right"
                onChange={ChangeFilterText}
                value={searchtext}
              />
            </div>
          </div>

          {/* Gift Card list */}
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  title="GiftCard List"
                  columns={columns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                  persistTableHead
                  sortServer
                  onSort={handleSort}
                  selectableRows
                  contextActions={contextActions}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Model  */}
      <DeleteConfirmationModal
        deleteApiUrl={`${config.giftcardBaseUrl}/giftcards/delete`}
      />

      {/* Cleanup */}
      <CleanupConfirmationModal
        CleanupConformationApiUrl={`${config.giftcardBaseUrl}/giftcards/deletepermanantely`}
      />
    </>
  );
};

export default GiftCard;
